import { useSelector } from "react-redux";
import Page404 from "../../../../components/Page404/Page403";
import { selectUserData } from "../../../../features/userSlice";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Maps from "../../../../components/DataCollection/Unifier/Maps/Maps";

const MapsScreen = () => {
  const response = useSelector(selectUserData);
  const hasUnifierViewMaps = CheckPermissions(
    response?.data?.products?.data_collection,
    "unifier",
    "view_maps"
  );

  return (
    <>
      {hasUnifierViewMaps ? (
        <>
          <Maps />
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default MapsScreen;
